mutation EntityDocumentDelete($input: EntityDocumentDeleteInput!) {
  entityDocumentDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
